/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanyCreateCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanyCreateCtrl', ["$http", "outlet", "ngToast", "$q", "$scope", "$timeout", "$state", "$window", "userinfo", "dialog", "localStorageService", "settings", function($http, outlet, ngToast, $q, $scope, $timeout, $state, $window,
   userinfo, dialog, localStorageService, settings) {
  $scope.fullName = outlet.name.substring(0, 60);
  $scope.shortName = outlet.name.substring(0, 20);
  $scope.buttonText = 'Create Company';

  userinfo.ready().then(function() {
    $scope.showPaymentWarning = userinfo.countCompanies() > 0;
  });

  $scope.register = function() {
    if ($scope.createCompanyForm.$invalid) {
      return;
    }

    var pos = (localStorageService.get('signup-pos')) ? localStorageService.get('signup-pos') : false;
    if (pos) {
      // var $firstRedirect = (pos == 'no-pos') ? 'Stock.ReportOverview' : 'Reports.Dashboard';
      var $firstRedirect = (pos == 'no-pos') ? 'Stock.ReportOverview' : 'Cashups.Overview';
      localStorageService.set('first-redirect', $firstRedirect);
    }

    //Send feedback back to button
    $scope.buttonText = 'Creating Company... Please wait';

    var loadingPromise = $q.defer();
    $scope.creatingCompany = loadingPromise.promise;

    $http.post(settings.apiHost + '/r/Companies', {
      FullName: $scope.fullName,
      ShortName: $scope.shortName,
      OutletId: outlet.outletId
    }).then(function() {
      $scope.buttonText = 'Creating Company... We\'re nearly there...';

      //If possible, refresh the session to update the userInfo.
      userinfo.initialize()
      .then(function() {

        loadingPromise.resolve();
        $scope.$close(true);
        localStorageService.set('company-created', 'true');
        localStorageService.remove('first-redirect');

        var pos = (localStorageService.get('signup-pos')) ? localStorageService.get('signup-pos') : false;

        var flagVar = (pos) ? ((pos == 'no-pos') ? 'dismissFlag.welcomeNoPosDialog' : 'dismissFlag.welcomePosDialog') : 'dismissFlag.welcomeDialog';
        var templateVar = (pos) ? ((pos == 'no-pos') ? 'welcomenoposdialog' : 'welcomeposdialog') : 'welcomedialog';
        var controllerVar = 'WelcomeDialogCtrl';
        // var companyCreated = (localStorageService.get('company-created')) ? localStorageService.get('company-created') : false;

        $timeout(function() {
          var dismissFlag = localStorageService.get(flagVar);
          var pos = (localStorageService.get('signup-pos')) ? localStorageService.get('signup-pos') : false;
          var companyCreated = (localStorageService.get('company-created')) ? localStorageService.get('company-created') : false;

          if ((!dismissFlag && !pos) || (pos && companyCreated)) {
            localStorageService.remove('signup-pos');
            localStorageService.remove('company-created');
            localStorageService.remove('first-redirect');
            dialog.open({
              size: 'lg',
              templateUrl: 'dialogs/welcome/' + templateVar + '.tpl.html',
              controller: controllerVar
            });
          }
        }, 3000);

        $state.go($firstRedirect);
      });
    }, function(response) {
      var message = response.data.message || 'Unable to create this company';
      ngToast.danger(message);
    });
  };
}]);
